import * as Sentry from '@sentry/react'
import { router } from '@inertiajs/react'

// Manage links and password reset links carry secret tokens in the path.
const SECRET_PATH = /\/(bookings|reset-password)\/[^/?#]+/g

function scrub(value) {
  return typeof value === 'string' ? value.replace(SECRET_PATH, '/$1/[FILTERED]') : value
}

function initialPage() {
  const script = document.querySelector('script[data-page="app"][type="application/json"]')
  return script ? JSON.parse(script.textContent) : null
}

function setUser(props) {
  Sentry.setUser(props.current_user ? { id: props.current_user.id } : null)
}

export function startSentry() {
  const page = initialPage()
  const config = page?.props.sentry
  if (!config) return

  Sentry.init({
    dsn: config.dsn,
    release: config.release,
    environment: config.environment,
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request) {
        event.request.url = scrub(event.request.url)
        if (event.request.headers) event.request.headers.Referer = scrub(event.request.headers.Referer)
      }
      return event
    },
    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.data) {
        for (const key of ['url', 'from', 'to']) breadcrumb.data[key] = scrub(breadcrumb.data[key])
      }
      return breadcrumb
    },
  })

  setUser(page.props)
  router.on('navigate', (event) => setUser(event.detail.page.props))
}
